import { gql } from '@apollo/client'
import { useMockExamsPlatformQuery } from 'resources/mock-exams-platform/use-mock-exams-platform-query'

export const KNOWLEDGE_AREAS_QUERY = gql`
query ActiveKnowledgeAreas {
    activeKnowledgeAreas {
        id
        name
        slug
    }
}
`

export const useKnowledgeAreas = () => {
  const { data: { activeKnowledgeAreas } = {}, loading, error } = useMockExamsPlatformQuery(KNOWLEDGE_AREAS_QUERY, {
    nodeName: 'activeKnowledgeAreas',
  })

  return {
    knowledgeAreas: activeKnowledgeAreas,
    loading,
    error,
  }
}
